module.exports = __webpack_public_path__ + "static/len_obl_prir-5411cceb9b4b4af33ce83d81003eee3c.jpg";